import type { Rebate } from '@urbanx/agx.agencies.client';

export const rebateFields = [
  {
    name: 'supplier',
    label: 'Name of Third Party/Supplier',
    placeholder: 'e.g. Realestate.com.au',
  },
  { name: 'service', label: 'Service', placeholder: 'e.g. Online advertising' },
  { name: 'estimatedAmount', label: 'Estimated amount', placeholder: 'e.g. Up to $250' },
] as const satisfies readonly { name: keyof Rebate; label: string; placeholder: string }[];

export type RebateField = (typeof rebateFields)[number];

export const resolveRebateFields = (rebates: readonly Rebate[]) =>
  Object.fromEntries(
    rebates.flatMap((_, index) =>
      rebateFields.map(({ name }) => [
        `rebates[${index}].${name}`,
        { active: true, visible: true, disabled: false, required: true },
      ])
    )
  );
